(ns com.theplantscape.plant-web.pages.login
  (:require
   [clojure.core.async :refer [<! chan go go-loop pub]]
   [com.theplantscape.plant-web.api.core :refer [api-errors]]
   [com.theplantscape.plant-web.api.user
    :refer [api-login2 fetch-webauth-challenge api-register-user api-user-reset-password api-user-request-reset-password]]
   [com.theplantscape.browser-utils.ensemble :as b]
   [com.theplantscape.plant-web.components.forms.core :refer [update-atom-hm]]
   [com.theplantscape.plant-web.components.tailwind.buttons :refer [button]]
   [com.theplantscape.web-ui.tailwind.info-tile :refer [ui-info-tile]]
   [com.theplantscape.plant-web.components.tailwind.forms.login
    :refer [login-form password-reset-form password-reset-request-form]]
   [com.theplantscape.plant-web.components.tailwind.forms.register-user-form
    :refer [register-new-user-form]]
   [com.theplantscape.plant-web.components.tailwind.menus :refer [menu-popup]]

   [com.theplantscape.plant-web.draw.state :refer [site-state]]
   [com.theplantscape.plant-web.pages.logout-page :refer [ui-page-logout]]
   [com.theplantscape.web-ui.tailwind.form.elements.form
    :refer [get-form-value set-form-value set-form-value-event]]
   [reagent.core :as r]
   [reitit.frontend.easy :as rfe]))

; publisher is just a normal channel
(def publisher (chan))

; publication is a thing we subscribe to
(def publication
  (pub publisher #(:topic %)))

(defn take-and-print [channel prefix]
  (go-loop []
    (prn prefix ": " (<! channel))))

(defn register-user-success! [state response]
  (swap! site-state assoc :auth response)
  #_(b/store-set-item! "auth" response)
  #_(rfe/push-state :homepage))

(defn request-success! [state response]
  (swap! state assoc :result response))

(defn login-success! [state response]
  (let [auth 
        (-> response
            (select-keys  [:user/display-name :user/email
                           :access_token :expiry])
            (assoc :created (js/Date.now)))]
    (prn "@@@@@")
    (prn auth)
    (swap! site-state assoc :auth auth)
    (b/store-set-item! "auth" auth)
    (rfe/push-state :route-user-profile)))

(defn login-failed! [state response]
  (swap! state assoc :errors [(api-errors response)])
  (swap! state assoc :form-validation (-> response :response :humanized))

  ;(swap! state update :errors conj (api-errors response))
  #_(swap! state update :form-validation concat (-> response  :response  :humanized)))

(defn on-submit-login [parent-state local-state]
  (go
    (let [response (<! (api-login2 (-> @parent-state :values)))]
      (swap! local-state assoc :disabled false)
      (if (first response)
        (login-success! local-state (last response))
        (login-failed! parent-state (last response))))))

(defn on-submit-request-reset-password [parent-state local-state]
  (go
    (let [response (<! (api-user-request-reset-password (-> @parent-state :values)))]
      (swap! local-state assoc :disabled false)
      (if (first response)
        (request-success! parent-state (last response))
        (login-failed! local-state (last response))))))

(defn on-submit-reset-password [parent-state local-state]
  (go
    (let [response (<! (api-user-reset-password (-> @parent-state :values)))]
      (swap! local-state assoc :disabled false)
      (if (first response)
        (request-success! local-state (last response))
        (login-failed! local-state (last response))))))

(defn on-submit-register [parent-state local-state]
  (go
    (let [response (<! (api-register-user (-> @parent-state :values)))]
      (swap! local-state assoc :disabled false)
      (if (first response)
        (register-user-success! parent-state (last response))
        (login-failed! parent-state (last response))))))

(defn on-webauth-fetch [user]
  #_(b/web-auth-store-user
     {:id (-> @user :values :user|email)
      :name (-> @user :values :user|email)
      :displayName (-> @user :values :displayname)})
  (b/web-auth-get-credentials))

(defn on-submit-register-webauth [user]
  (prn "on-submit-register")
  (b/web-auth-store-user
   {:id (-> @user :values :username)
    :name (-> @user :values :username)
    :displayName (-> @user :values :displayname)})
  (b/web-auth-create-credentials (partial swap! user assoc-in [:values :user|public-key])))

(defn init-login []
  (fetch-webauth-challenge
   "get"
   (fn challenge [r]
     (->>
      (update-in r [:publicKey :challenge] b/to-js-array-buffer)
      (reset! b/biometric-auth)))))

(defn init-registration []
  (fetch-webauth-challenge
   "create"
   (fn challenge [r]
     (->>
      (update-in r [:publicKey :challenge] b/to-js-array-buffer)
      (reset! b/biometric-auth)))))

(defn logout-page []
  (swap! site-state assoc :auth  {})
  [ui-page-logout])

(defn login-button []
  (prn "@@@@@@@@@@@@@@@@@@")
  (prn     (b/store-get-item "auth"))
  (prn     (:expiry (b/store-get-item "auth")))
  
   (prn (js/Date.now))
   (prn (+ (-> @site-state :auth :created)
                 (-> @site-state :auth :expiry)))
  (if (or (empty? (-> @site-state :auth :access_token))
          (< (js/Date.now)
             (+ (-> @site-state :auth :created)
                (-> @site-state :auth :expiry)))
          )
    [:div
     [:a.mr-4 {:href (rfe/href :login)} [button "Login"]]
     [:a {:href (rfe/href :register)} [button "Sign Up"]]]
    [menu-popup
     (-> @site-state :auth :user/display-name)
     [{:title "Profile" :href (rfe/href :route-user-profile)}
      {:title "Settings" :href (rfe/href :settings)}
      {:title "Logout" :href (rfe/href :logout)}]]))

(defn register-new-user-page [{:keys [path-params] :as route}]
  (let [form-state (r/atom {})
        on-submit-cb (partial on-submit-register form-state)
        form-change (partial update-atom-hm form-state)]
    (fn [{:keys [path-params] :as route}]
      [:main.pa3.black-80.m-auto
       [:div.m-auto {:class "w-2/3"}
        (when (-> @form-state :errors)
          [ui-info-tile
           {:title "An error occured."
            :image "https://img.theplantscape.com/api/image/do/404-image-01.jpg?p=h-24"
            :description (-> @form-state :errors)}])]
       [register-new-user-form
        "Register account"
        form-state
        {:on-submit on-submit-cb #_on-submit-register #_(b/web-auth-create-credentials)
         :on-webauth on-submit-register-webauth
         :on-change form-change}]])))

(defn login-page [{:keys [path-params] :as route}]
  (let [form-state (r/atom {})
        on-webauth-cb (partial on-webauth-fetch form-state)
        on-submit-cb (partial on-submit-login form-state)
        set-value (partial set-form-value-event form-state)
        get-value (partial get-form-value form-state)

        form-change (partial update-atom-hm form-state)]
    (fn [{:keys [path-params] :as route}]
      [:main.pa3.black-80.m-auto
       [:div.m-auto {:class "w-2/3"}
        (when (-> @form-state :errors)
          [ui-info-tile
           {:title "An error occured."
            :image "https://img.theplantscape.com/api/image/do/404-image-01.jpg?p=h-24"
            :description (-> @form-state :errors)}])]
       [:div.min-h-screen.bg-gray-100.flex.flex-col.sm:py-12

        [login-form
         "Login"
         {:route-forgot-password (rfe/href :route-forgot-password)
          :route-homepage (rfe/href :homepage)
          :set-value set-value
          :get-value get-value
          :on-submit on-submit-cb
          :on-webauth on-webauth-cb
          :on-change form-change}]]])))

(defn reset-password-page [{:keys [query path] :as route}]
  (let [form-state (r/atom {:values query})
        on-submit-request-cb (partial on-submit-request-reset-password form-state)
        on-submit-reset-cb (partial on-submit-reset-password form-state)
        form-change (partial update-atom-hm form-state)]
    (fn [{:keys [query path] :as route}]
      [:div
       [:main.pa3.black-80
        (cond
          (-> @form-state :result :state)
          [ui-info-tile
           {:title "Password reset request sent"
            :description "Password reset request sent, if this is a valid account you should receive an email shortly."}]

          (seq query)
          [password-reset-form
           "Please enter your new auth details"
           form-state
           {:on-submit on-submit-reset-cb
            :on-webauth on-submit-register-webauth
            ;;:on-login-no-password on-submit-login-webauth
            :on-change form-change}]

          :else
          [password-reset-request-form
           "Request to reset password"
           {:on-submit on-submit-request-cb
            :on-change form-change}])]])))

